declare let require: any;
const mixitup = require('../node_modules/mixitup/dist/mixitup.min.js');
const mixitupPagination = require('../wwwroot/js/mixitup-pagination.min.js');

mixitup.use(mixitupPagination);

export const initFiltering = () => {
  const preLoadCategory = document.getElementById(
    'chosen-category'
  ) as HTMLInputElement;
  
  let toFilter = 'all';
  if (preLoadCategory.value !== 'all') {
    toFilter = '.' + preLoadCategory.value;
  }
  const mixer = mixitup('.filter-container', {
    controls: {
      toggleLogic: 'and',
    },
    load: {
      filter: toFilter,
    },
    animation: {
      effects: 'fade translateX(-20px)',
    },
    pagination: {
      limit: 12,
      hidePageListIfSinglePage: true,
    },
  });
};
